import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  margin-bottom: 2em;
  padding-top: 1.5em;
  background-color: ${({ theme }) => theme.neutral.white};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  user-select: none;
`;
